module.exports = __webpack_public_path__ + "img/marker_selected.9bed4c10.svg";